const root = 'Alert'

export const TestId = {
  root,
  actionButton: `${root}-AlertActionButton`,
  dismissButton: `${root}-DismissAlertButton`,
}
